import { render, staticRenderFns } from "./DocumentAllocations.vue?vue&type=template&id=0ae59a63&scoped=true&"
import script from "./DocumentAllocations.vue?vue&type=script&lang=js&"
export * from "./DocumentAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae59a63",
  null
  
)

export default component.exports